import { API_URL } from './apiUrl'

export const CRM_API_URL = `${API_URL}crm/`
